<template>
  <div>
    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Settings</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibility = false"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="mt-1" v-if="settObj">
          <b-col md="12">
            <b-form-group
              label="Opening Balance"
              invalid-feedback="Opening Balance is required."
              ref="bal"
            >
              <b-form-input
                placeholder="Enter balance here"
                v-model="settObj.valueNumber"
              />
            </b-form-group>
          </b-col>

          <b-col md="12" class="mt-1">
            <b-button
              variant="success"
              @click="saveSetting()"
              :disabled="request"
              block
            >
              <b-spinner v-if="request" small type="grow" />
              <span v-else>{{ $t("Save") }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
      <sidebar-content />
    </b-sidebar>

    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility2"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Settings</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibility2 = false"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="mt-1">
          <b-col md="12">
            <b-form-group
              label="Select Month"
              invalid-feedback="Month is required."
              ref="month"
            >
              <v-select
                v-model="dateObj.month"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="months"
                label="text"
                :reduce="(opt) => opt.value"
                :clearable="false"
                placeholder="Select month"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              label="Select Year"
              invalid-feedback="year is required."
              ref="year"
            >
              <v-select
                v-model="dateObj.year"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="years"
                :clearable="false"
                placeholder="Select year"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              label="Date"
              invalid-feedback="Date is required"
              ref="date"
            >
              <flat-pickr
                :config="config"
                v-model="rangeDate"
                class="form-control"
                :placeholder="$t('Select Date')"
                @on-change="setDate"
              />
            </b-form-group>
          </b-col>

          <b-col md="12" class="mt-1">
            <b-button
              variant="success"
              @click="saveData()"
              :disabled="saving"
              block
            >
              <b-spinner v-if="saving" small type="grow" />
              <span v-else>Generate</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
      <sidebar-content />
    </b-sidebar>

    <b-card>
      <div class="recon-toolbar mb-3">
        <div class="recon-toolbar-left">
          <b-button @click="AddOpen()" variant="primary">
            <span class="align-middle">Generate Report</span>
          </b-button>
          <b-button
            variant="outline-primary"
            class="btn-icon"
            v-b-tooltip.hover.top
            title="Set Opening Balance"
            @click="openSetting()"
            :disabled="settLoading"
          >
            <b-spinner v-if="settLoading" small />
            <feather-icon v-else icon="SettingsIcon" />
          </b-button>
        </div>

        <div class="recon-toolbar-right">
          <b-button
            class="recon-print-full-btn"
            variant="info"
            @click="openFullReconciliationReport()"
            :disabled="dataLoading || items.length === 0"
          >
            <feather-icon icon="FileTextIcon" class="mr-50" />
            <span>Print Full Report</span>
          </b-button>
          <b-button
            variant="success"
            @click="printReconciliationReport()"
            :disabled="dataLoading || items.length === 0"
            v-b-tooltip.hover.top
            title="Print reconciliation summary"
          >
            <feather-icon icon="PrinterIcon" class="mr-50" />
            <span>Print Report</span>
          </b-button>
        </div>
      </div>
      <b-table
        class="mt-1 recon-data-table"
        :items="items"
        :fields="fields"
        :busy="dataLoading"
        responsive
        show-empty
        small
        striped
        hover
      >
        <template #table-busy>
          <div
            class="d-flex justify-content-center mb-3"
            style="margin-top: 50px"
          >
            <b-spinner
              style="width: 3rem; height: 3rem"
              type="grow"
              variant="primary"
              label="Spinning"
            ></b-spinner>
          </div>
        </template>
        <template #cell(datestr)="data">
          <div class="recon-date-cell">
            <span class="recon-date-range">{{ data.value }}</span>
            <span class="recon-date-month">
              {{ monthName(data.item.month) }} {{ data.item.year }}
            </span>
          </div>
        </template>
        <template #cell(prevBalance)="data">
          <span class="recon-value-badge">{{ formatNumber(data.value) }}</span>
        </template>
        <template #cell(dues)="data">
          <span
            class="recon-value-badge recon-value-badge--clickable"
            @click="openFeeBreakdownModal(data.item, data.index, 'actualFee')"
          >
            <b-spinner
              v-if="isFeeBreakdownLoading('actualFee', data.index)"
              small
              type="grow"
            />
            <span v-else>{{ formatNumber(data.value) }}</span>
          </span>
        </template>
        <template #cell(badDebtsCount)="data">
          <span
            class="recon-value-badge recon-value-badge--clickable"
            @click="openReport(data.item, 'left')"
          >
            {{ data.value }}
          </span>
        </template>
        <template #cell(badDebts)="data">
          <span
            class="recon-value-badge recon-value-badge--clickable"
            @click="openReport(data.item, 'left')"
          >
            {{ formatNumber(data.value) }}
          </span>
        </template>
        <template #cell(discountCount)="data">
          <span class="recon-value-badge">{{ data.value }}</span>
        </template>
        <template #cell(discount)="data">
          <span
            class="recon-value-badge recon-value-badge--clickable"
            @click="openFeeBreakdownModal(data.item, data.index, 'discount')"
          >
            <b-spinner
              v-if="isFeeBreakdownLoading('discount', data.index)"
              small
              type="grow"
            />
            <span v-else>{{ formatNumber(data.value) }}</span>
          </span>
        </template>
        <template #cell(exemptCount)="data">
          <span
            class="recon-value-badge recon-value-badge--clickable"
            @click="openReport(data.item, 'exempt')"
          >
            {{ data.value }}
          </span>
        </template>
        <template #cell(exempted)="data">
          <span
            class="recon-value-badge recon-value-badge--clickable"
            @click="openReport(data.item, 'exempt')"
          >
            {{ formatNumber(data.value) }}
          </span>
        </template>
        <template #cell(collection)="data">
          <span
            class="recon-value-badge recon-value-badge--clickable recon-value-badge--received"
            @click="openReport(data.item, 'collection')"
          >
            {{ formatNumber(data.value) }}
          </span>
        </template>
        <template #cell(advanceCollection)="data">
          <span
            class="recon-value-badge recon-value-badge--clickable recon-value-badge--received"
            @click="data.value > 0 && openFeeBreakdownModal(data.item, data.index, 'advance')"
          >
            <b-spinner
              v-if="isFeeBreakdownLoading('advance', data.index)"
              small
              type="grow"
            />
            <span v-else>{{ formatNumber(data.value) }}</span>
          </span>
        </template>
        <template #cell(balance)="data">
          <span class="recon-value-badge recon-value-badge--balance">
            {{ formatNumber(data.value) }}
          </span>
        </template>
      </b-table>
    </b-card>

    <b-modal
      v-model="showFeeBreakdownModal"
      :title="feeBreakdownModalTitle"
      size="lg"
      centered
      scrollable
      ok-only
      ok-title="Close"
      @hidden="resetFeeBreakdownModal"
    >
      <div v-if="feeBreakdownModalItem" class="fee-modal-meta mb-3">
        <div class="fee-modal-meta-row">
          <span class="fee-modal-meta-label">Date Range</span>
          <span class="fee-modal-meta-value">
            {{ feeBreakdownModalItem.datestr }}
          </span>
        </div>
        <div class="fee-modal-meta-row">
          <span class="fee-modal-meta-label">Month</span>
          <span class="fee-modal-meta-value">
            {{ monthName(feeBreakdownModalItem.month) }}
            {{ feeBreakdownModalItem.year }}
          </span>
        </div>
        <div class="fee-modal-meta-row">
          <span class="fee-modal-meta-label">{{
            feeBreakdownModalTotalLabel
          }}</span>
          <span class="fee-modal-meta-value fee-modal-meta-total">
            {{ formatNumber(feeBreakdownModalTotalValue) }}
          </span>
        </div>
        <div class="fee-modal-meta-row">
          <span class="fee-modal-meta-label">Summary</span>
          <span class="fee-modal-meta-value">
            {{ feeBreakdownModalList.length }}
            {{ feeBreakdownModalList.length === 1 ? "Fee Type" : "Fee Types" }}
            <!-- ·
            {{ formatNumber(feeBreakdownModalStudentTotal) }} Students -->
          </span>
        </div>
      </div>

      <div v-if="feeBreakdownModalLoading" class="text-center py-3">
        <b-spinner variant="primary" />
        <p class="text-muted small mt-1 mb-0">Loading fee details...</p>
      </div>

      <div
        v-else-if="!feeBreakdownModalList.length"
        class="text-center py-3 text-muted"
      >
        No fee details found
      </div>

      <div v-else>
        <b-table
          :items="feeBreakdownModalList"
          :fields="feeBreakdownFields"
          responsive
          small
          striped
          bordered
          hover
          class="mb-0 actual-fee-breakdown-table"
          show-empty
          no-footer-sorting
        >
          <template #cell(sno)="data">
            {{ data.index + 1 }}
          </template>
          <template #cell(feeTypeName)="data">
            <button
              type="button"
              class="btn btn-link p-0 fee-breakdown-link"
              :disabled="isFeeStudentLoading(data.item)"
              @click="openFeeStudentModal(data.item)"
            >
              <b-spinner
                v-if="isFeeStudentLoading(data.item)"
                small
                type="grow"
              />
              <span v-else>{{ data.value }}</span>
            </button>
          </template>
          <template #cell(studentCount)="data">
            <button
              type="button"
              class="btn btn-link p-0 fee-breakdown-count-link"
              :disabled="isFeeStudentLoading(data.item)"
              @click="openFeeStudentModal(data.item)"
            >
              <b-spinner
                v-if="isFeeStudentLoading(data.item)"
                small
                type="grow"
              />
              <span v-else>{{ formatNumber(data.value) }}</span>
            </button>
          </template>
          <template #cell(amount)="data">
            <strong>{{ formatNumber(data.value) }}</strong>
          </template>
          <template #custom-foot>
            <b-tr v-if="unadjustedAmount != 0">
              <b-td class="text-center">{{ feeBreakdownModalList.length + 1 }}</b-td>
              <b-td class="unadjusted-fee-text">Other Fees</b-td>
              <b-td class="text-center">-</b-td>
              <b-td class="text-right">
                <strong>{{ formatNumber(unadjustedAmount) }}</strong>
              </b-td>
            </b-tr>
            <b-tr>
              <b-td class="text-center"></b-td>
              <b-td class="font-weight-bolder">Grand Total</b-td>
              <b-td class="text-center">
                <!-- <strong>{{ formatNumber(feeBreakdownModalStudentTotal) }}</strong> -->
              </b-td>
              <b-td class="text-right">
                <!-- showing original saved value as diff is already showing above -->
                <strong>{{ formatNumber(feeBreakdownModalTotalValue) }}</strong>
              </b-td>
            </b-tr>
          </template>
        </b-table>
      </div>
    </b-modal>

    <b-modal
      v-model="showFeeStudentModal"
      :title="feeStudentModalTitle"
      size="lg"
      centered
      scrollable
      modal-class="fee-student-modal"
      body-class="fee-student-modal-body"
      ok-only
      ok-title="Close"
      @hidden="resetFeeStudentModal"
    >
      <div v-if="feeStudentModalFeeRow" class="fee-modal-meta mb-3">
        <div class="fee-modal-meta-row">
          <span class="fee-modal-meta-label">Date Range</span>
          <span class="fee-modal-meta-value">
            {{ feeBreakdownModalItem ? feeBreakdownModalItem.datestr : "—" }}
          </span>
        </div>
        <div class="fee-modal-meta-row">
          <span class="fee-modal-meta-label">Fee Type</span>
          <span class="fee-modal-meta-value">
            {{ feeStudentModalFeeRow.feeTypeName }}
          </span>
        </div>
        <div class="fee-modal-meta-row">
          <span class="fee-modal-meta-label">Students</span>
          <span class="fee-modal-meta-value">
            {{ formatNumber(feeStudentModalFeeRow.studentCount) }}
          </span>
        </div>
        <div class="fee-modal-meta-row">
          <span class="fee-modal-meta-label">{{
            feeBreakdownModalType === "discount" ? "Discount" : feeBreakdownModalType === "advance" ? "Advance Fee" : "Actual Fee"
          }}</span>
          <span class="fee-modal-meta-value fee-modal-meta-total">
            {{
              feeStudentModalRows.length
                ? formatNumber(feeStudentModalNetTotal)
                : formatNumber(feeStudentModalFeeRow.amount)
            }}
          </span>
        </div>
      </div>

      <div v-if="feeStudentModalLoading" class="text-center py-3">
        <b-spinner variant="primary" />
        <p class="text-muted small mt-1 mb-0">Loading student details...</p>
      </div>

      <div
        v-else-if="!feeStudentModalRows.length"
        class="text-center py-3 text-muted"
      >
        No student details found
      </div>

      <div v-else class="fee-student-table-wrap">
        <b-table
          :items="feeStudentModalRows"
          :fields="feeStudentFields"
          small
          striped
          bordered
          hover
          class="mb-0 fee-student-details-table"
          show-empty
          foot-clone
          no-footer-sorting
        >
          <template #cell(grNo)="data">
            <span class="font-weight-bolder">{{ data.value }}</span>
          </template>
          <template #cell(studentName)="data">
            <span class="font-weight-bolder">{{ data.value }}</span>
          </template>
          <template #cell(amount)="data">
            <strong>{{ formatNumber(data.value) }}</strong>
          </template>
          <template #cell(status)="data">
            <b-badge :variant="getFeeStatusVariant(data.value)">
              {{ data.value }}
            </b-badge>
          </template>
          <template #foot(sno)="">
            <span></span>
          </template>
          <template #foot(grNo)="">
            <span class="font-weight-bolder">Grand Total</span>
          </template>
          <template #foot(studentName)="">
            <span></span>
          </template>
          <template #foot(fatherName)="">
            <span></span>
          </template>
          <template #foot(amount)="">
            <strong>{{ formatNumber(feeStudentModalNetTotal) }}</strong>
          </template>
          <template #foot(status)="">
            <span></span>
          </template>
        </b-table>
      </div>

      <template #modal-footer>
        <b-button variant="success" @click="printFeeStdRecords()">
          <feather-icon icon="PrinterIcon" class="mr-50" />
          <span>Print</span>
        </b-button>
        <b-button variant="primary" @click="showFeeStudentModal = false">
          <span>Close</span>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import {
  BCard,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BLink,
  BBadge,
  BPagination,
  BImg,
  VBTooltip,
  BFormCheckbox,
  BFormGroup,
  BForm,
  BMediaAside,
  BSpinner,
  BSidebar,
  BInputGroupPrepend,
  BFormTextarea,
  BInputGroup,
  BDropdown,
  BDropdownItem,
  BFormSpinbutton,
  BAvatar,
  BModal,
  BTr,
  BTd,
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BLink,
    BBadge,
    BPagination,
    BImg,
    BFormCheckbox,
    BFormGroup,
    BForm,
    BMediaAside,
    BSpinner,
    BSidebar,
    BInputGroupPrepend,
    BFormTextarea,
    BInputGroup,
    BDropdown,
    BDropdownItem,
    BFormSpinbutton,
    BAvatar,
    BModal,
    BTr,
    BTd,
    vSelect,
    flatPickr,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      config: {
        mode: "range",
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
      },
      dataLoading: false,
      fields: [
        { label: "date", key: "datestr" },
        { label: "last balance", key: "prevBalance" },
        { label: "actual fee", key: "dues" },
        // { label: "total", key: "total" },
        { label: "left", key: "badDebtsCount" },
        { label: "left total", key: "badDebts" },
        { label: "discount", key: "discountCount" },
        { label: "discount total", key: "discount" },
        { label: "exemption", key: "exemptCount" },
        { label: "exemption total", key: "exempted" },
        { label: "received", key: "collection" },
        { label: "advance", key: "advanceCollection" },
        { label: "balance", key: "balance" },
      ],
      items: [],
      visibility: false,
      settLoading: false,
      settObj: null,
      request: false,
      visibility2: false,
      rangeDate: null,
      dateObj: {
        dtFrom: null,
        dtTo: null,
        month: 0,
        year: 0,
      },
      months: [
        { text: "January", value: 1 },
        { text: "February", value: 2 },
        { text: "March", value: 3 },
        { text: "April", value: 4 },
        { text: "May", value: 5 },
        { text: "June", value: 6 },
        { text: "July", value: 7 },
        { text: "August", value: 8 },
        { text: "September", value: 9 },
        { text: "October", value: 10 },
        { text: "November", value: 11 },
        { text: "December", value: 12 },
      ],
      years: [
        2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026,
        2027, 2028, 2029, 2030,
      ],
      saving: false,
      reportDomain: this.$store.state.report.replace(/_/g, ""),
      feeBreakdownCache: {},
      feeBreakdownLoadingKey: null,
      showFeeBreakdownModal: false,
      feeBreakdownModalItem: null,
      feeBreakdownModalIndex: null,
      feeBreakdownModalType: "actualFee",
      feeBreakdownFields: [
        {
          key: "sno",
          label: "S.No",
          thClass: "text-center",
          tdClass: "text-center",
          thStyle: { width: "60px" },
        },
        {
          key: "feeTypeName",
          label: "Fee Type",
          thStyle: { minWidth: "180px" },
        },
        {
          key: "studentCount",
          label: "Students",
          thClass: "text-center",
          tdClass: "text-center",
          thStyle: { width: "110px" },
        },
        {
          key: "amount",
          label: "Amount",
          thClass: "text-right",
          tdClass: "text-right",
          thStyle: { width: "150px" },
        },
      ],
      feeStudentCache: {},
      feeStudentLoadingKey: null,
      showFeeStudentModal: false,
      feeStudentModalFeeRow: null,
    };
  },
  computed: {
    feeBreakdownModalTitle() {
      return this.feeBreakdownModalType === "discount"
        ? "Discount Breakdown"
        : this.feeBreakdownModalType === "advance" 
        ? "Advance Fee Breakdown" 
        : "Actual Fee Breakdown";
    },
    feeBreakdownModalTotalLabel() {
      return this.feeBreakdownModalType === "discount"
        ? "Discount Total"
        : this.feeBreakdownModalType === "advance" 
        ? "Advance Fee" 
        : "Actual Fee";
    },
    feeBreakdownModalTotalValue() {
      if (!this.feeBreakdownModalItem) return 0;
      return this.feeBreakdownModalType === "discount"
        ? this.feeBreakdownModalItem.discount
        : this.feeBreakdownModalType === "advance" 
        ? this.feeBreakdownModalItem.advanceCollection 
        : this.feeBreakdownModalItem.dues;
    },
    feeBreakdownModalLoading() {
      if (this.feeBreakdownModalIndex === null || !this.feeBreakdownModalType) {
        return false;
      }
      return (
        this.feeBreakdownLoadingKey ===
        this.getFeeBreakdownKey(
          this.feeBreakdownModalType,
          this.feeBreakdownModalIndex
        )
      );
    },
    feeBreakdownModalList() {
      if (this.feeBreakdownModalIndex === null || !this.feeBreakdownModalType) {
        return [];
      }
      return this.getFeeBreakdown(
        this.feeBreakdownModalIndex,
        this.feeBreakdownModalType
      );
    },
    feeBreakdownModalTotal() {
      return this.feeBreakdownModalList.reduce(
        (sum, fee) => sum + (Number(fee.amount) || 0),
        0
      );
    },
    feeBreakdownModalStudentTotal() {
      return this.feeBreakdownModalList.reduce(
        (sum, fee) => sum + (Number(fee.studentCount) || 0),
        0
      );
    },
    unadjustedAmount(){
      return this.feeBreakdownModalTotalValue - this.feeBreakdownModalTotal;
    },
    feeStudentFields() {
      return [
        {
          key: "sno",
          label: "S.No",
          thClass: "text-center",
          tdClass: "text-center",
          thStyle: { width: "50px" },
        },
        {
          key: "grNo",
          label: "GR No",
          thStyle: { width: "80px" },
        },
        {
          key: "studentName",
          label: "Student",
          thStyle: { minWidth: "130px" },
        },
        {
          key: "fatherName",
          label: "Father",
          thStyle: { minWidth: "120px" },
        },
        {
          key: "amount",
          label:
            this.feeBreakdownModalType === "discount"
              ? "Discount"
              : this.feeBreakdownModalType === "advance" 
              ? "Advance Fee" 
              : "Actual Fee",
          thClass: "text-right",
          tdClass: "text-right",
          thStyle: { width: "110px" },
        },
        // {
        //   key: "status",
        //   label: "Status",
        //   thClass: "text-center",
        //   tdClass: "text-center",
        //   thStyle: { width: "80px" },
        // },
      ];
    },
    feeStudentModalTitle() {
      if (!this.feeStudentModalFeeRow) {
        return "Student Details";
      }
      return `Students - ${this.feeStudentModalFeeRow.feeTypeName}`;
    },
    feeStudentModalLoading() {
      if (!this.feeStudentModalFeeRow) return false;
      return (
        this.feeStudentLoadingKey ===
        this.getFeeStudentKey(this.feeStudentModalFeeRow)
      );
    },
    feeStudentModalList() {
      if (!this.feeStudentModalFeeRow) return [];
      return this.getFeeStudentList(this.feeStudentModalFeeRow);
    },
    feeStudentModalRows() {
      return this.buildFeeStudentRows(
        this.feeStudentModalList,
        this.feeBreakdownModalType
      );
    },
    feeStudentModalNetTotal() {
      return this.feeStudentModalRows.reduce(
        (sum, row) => sum + (Number(row.amount) || 0),
        0
      );
    },
  },
  created() {
    // this.$store.commit("setReconilData", []);
    // this.items = this.$store.state.reconilData;
    this.LoadData();
  },
  methods: {
    ...mapActions({
      get: "get",
      post: "post",
      postObj: "postObj",
      put: "put",
      delete: "delete",
    }),

    printFeeStdRecords() {
      if (!this.feeStudentModalFeeRow) return;

      const dateRange = this.feeBreakdownModalItem
        ? this.feeBreakdownModalItem.datestr
        : "—";
      const feeType = this.feeStudentModalFeeRow.feeTypeName;
      const studentCount = this.formatNumber(
        this.feeStudentModalFeeRow.studentCount
      );
      const netTotalVal = this.feeStudentModalRows.length
        ? this.formatNumber(this.feeStudentModalNetTotal)
        : this.formatNumber(this.feeStudentModalFeeRow.amount);

      const amountField =
        this.feeBreakdownModalType === "discount" ? "Discount" 
                : this.feeBreakdownModalType === "advance" 
                ? "Advance Fee" 
                : "Actual Fee";

      // Generate table headers based on active fields
      const tableHeaders = this.feeStudentFields
        .map((field) => {
          const styleStr = field.thStyle
            ? Object.entries(field.thStyle)
                .map(
                  ([k, v]) =>
                    `${k.replace(/[A-Z]/g, (m) => `-${m.toLowerCase()}`)}:${v}`
                )
                .join(";")
            : "";
          const classStr = field.thClass ? `class="${field.thClass}"` : "";
          return `<th ${classStr} style="${styleStr}">${field.label}</th>`;
        })
        .join("");

      // Generate table rows
      const tableRows = this.feeStudentModalRows
        .map((row, index) => {
          const cells = this.feeStudentFields
            .map((field) => {
              const val = row[field.key] !== undefined ? row[field.key] : "—";
              let tdClass = "";
              if (field.tdClass) {
                tdClass = `class="${field.tdClass}"`;
              } else if (
                field.thClass &&
                (field.thClass.includes("text-center") ||
                  field.thClass.includes("text-right"))
              ) {
                tdClass = `class="${field.thClass}"`;
              }

              if (field.key === "grNo" || field.key === "studentName") {
                return `<td ${tdClass}><span class="font-weight-bolder">${val}</span></td>`;
              }
              if (field.key === "amount") {
                return `<td ${tdClass}><strong>${this.formatNumber(
                  val
                )}</strong></td>`;
              }
              if (field.key === "status") {
                return `<td ${tdClass}><span class="status-badge status-${String(
                  val
                ).toLowerCase()}">${val}</span></td>`;
              }
              return `<td ${tdClass}>${val}</td>`;
            })
            .join("");
          return `<tr ${
            index % 2 === 0 ? 'class="even-row"' : ""
          }>${cells}</tr>`;
        })
        .join("");

      // Generate table footer as a regular row to avoid repeating on every page
      const footerCells = this.feeStudentFields
        .map((field) => {
          let tdClass = "";
          if (field.tdClass) {
            tdClass = `class="${field.tdClass}"`;
          } else if (
            field.thClass &&
            (field.thClass.includes("text-center") ||
              field.thClass.includes("text-right"))
          ) {
            tdClass = `class="${field.thClass}"`;
          }

          if (field.key === "grNo") {
            return `<td ${tdClass}><span class="font-weight-bolder">Grand Total</span></td>`;
          }
          if (field.key === "amount") {
            return `<td ${tdClass}><strong>${this.formatNumber(
              this.feeStudentModalNetTotal
            )}</strong></td>`;
          }
          return `<td ${tdClass}></td>`;
        })
        .join("");

      const printHtml = `
        <!DOCTYPE html>
        <html lang="en">
        <head>
          <meta charset="UTF-8">
          <title>Student Fee Details - ${feeType}</title>
          <style>
            * { margin: 0; padding: 0; box-sizing: border-box; }
            body { font-family: 'Arial', sans-serif; line-height: 1.4; color: #333; padding: 20px; font-size: 12px; }
            .print-header { text-align: center; margin-bottom: 25px; padding: 20px; background: #7367f0; color: white; border-radius: 12px; }
            .print-header h1 { font-size: 24px; margin-bottom: 8px; font-weight: bold; }
            .fee-modal-meta { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px 20px; padding: 15px 20px; border: 1px solid #ebe9f1; border-radius: 8px; background: #f8f9fa; margin-bottom: 25px; }
            .fee-modal-meta-label { color: #6e6b7b; font-size: 10px; font-weight: 600; text-transform: uppercase; }
            .fee-modal-meta-value { color: #2f2b3d; font-size: 13px; font-weight: 600; margin-left: 4px; }
            .report-table { width: 100%; border-collapse: collapse; margin-bottom: 25px; }
            .report-table th { background: #7367f0; color: white; padding: 10px 12px; text-align: left; font-size: 11px; }
            .report-table td { padding: 10px 12px; border-bottom: 1px solid #e9ecef; font-size: 11px; }
            .report-table tr.even-row { background-color: #f8f9fa; }
            .report-table tr.grand-total-row td { background-color: #f8f9fa !important; font-weight: bold; border-top: 2px solid #7367f0; border-bottom: 2px solid #7367f0; -webkit-print-color-adjust: exact; color-adjust: exact; }
            .text-center { text-align: center; } .text-right { text-align: right; } .font-weight-bolder { font-weight: bold; }
            .status-badge { display: inline-block; padding: 4px 8px; border-radius: 4px; font-size: 10px; font-weight: 600; text-transform: uppercase; }
            .status-paid { background-color: #d4edda; color: #155724; } .status-unpaid { background-color: #f8d7da; color: #721c24; } .status-partial { background-color: #fff3cd; color: #856404; }
            @media print { body { padding: 10px; } .print-header { background: #7367f0 !important; -webkit-print-color-adjust: exact; } .report-table th { background: #7367f0 !important; -webkit-print-color-adjust: exact; } }
          </style>
        </head>
        <body>
          <div class="print-header">
            <h1>Student Fee Details</h1>
            <p>Generated on ${new Date().toLocaleDateString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            })}</p>
          </div>
          <div class="fee-modal-meta">
            <div class="fee-modal-meta-row"><span class="fee-modal-meta-label">Date Range:</span><span class="fee-modal-meta-value">${dateRange}</span></div>
            <div class="fee-modal-meta-row"><span class="fee-modal-meta-label">Fee Type:</span><span class="fee-modal-meta-value">${feeType}</span></div>
            <div class="fee-modal-meta-row"><span class="fee-modal-meta-label">Students:</span><span class="fee-modal-meta-value">${studentCount}</span></div>
            <div class="fee-modal-meta-row"><span class="fee-modal-meta-label">${amountField}:</span><span class="fee-modal-meta-value">${netTotalVal}</span></div>
          </div>
          <table class="report-table">
            <thead><tr>${tableHeaders}</tr></thead>
            <tbody>
              ${
                tableRows ||
                '<tr><td colspan="100%" class="text-center">No student details found</td></tr>'
              }
              ${
                tableRows
                  ? `<tr class="grand-total-row">${footerCells}</tr>`
                  : ""
              }
            </tbody>
          </table>
        </body>
        </html>
      `;

      let iframe = document.getElementById("print-fee-records-iframe");
      if (iframe) iframe.parentNode.removeChild(iframe);
      iframe = document.createElement("iframe");
      iframe.id = "print-fee-records-iframe";
      iframe.style.position = "fixed";
      iframe.style.right = "0";
      iframe.style.bottom = "0";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "0";
      document.body.appendChild(iframe);

      const doc = iframe.contentWindow.document;
      doc.open();
      doc.write(printHtml);
      doc.close();

      setTimeout(() => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
      }, 150);

      iframe.contentWindow.addEventListener("afterprint", () => {
        if (iframe && iframe.parentNode) iframe.parentNode.removeChild(iframe);
      });
    },

    monthName(val) {
      let obj = this.months.find((el) => el.value == val);
      return obj ? obj.text.slice(0, 3) : "";
    },
    getFeeBreakdownKey(type, index) {
      return `${type}_${index}`;
    },

    getFeeBreakdown(index, type) {
      return this.feeBreakdownCache[this.getFeeBreakdownKey(type, index)] || [];
    },

    isFeeBreakdownLoading(type, index) {
      return (
        this.showFeeBreakdownModal &&
        this.feeBreakdownModalType === type &&
        this.feeBreakdownModalIndex === index &&
        this.feeBreakdownLoadingKey === this.getFeeBreakdownKey(type, index)
      );
    },

    openFeeBreakdownModal(item, index, type) {
      this.feeBreakdownModalItem = item;
      this.feeBreakdownModalIndex = index;
      this.feeBreakdownModalType = type;
      this.showFeeBreakdownModal = true;
      this.loadFeeBreakdown(item, index, type);
    },

    resetFeeBreakdownModal() {
      this.feeBreakdownModalItem = null;
      this.feeBreakdownModalIndex = null;
      this.feeBreakdownModalType = "actualFee";
    },

    buildReconFeePayload(item) {
      return {
        dtFrom: item.dtFrom ? item.dtFrom.split("T")[0] : null,
        dtTo: item.dtTo ? item.dtTo.split("T")[0] : null,
        month: item.month,
        year: item.year,
      };
    },

    async loadFeeBreakdown(item, index, type) {
      const cacheKey = this.getFeeBreakdownKey(type, index);

      if (
        this.feeBreakdownCache[cacheKey] ||
        this.feeBreakdownLoadingKey === cacheKey
      ) {
        return;
      }

      this.feeBreakdownLoadingKey = cacheKey;

      try {
        const res = await this.post({
          url:
            this.$store.state.domain +
            "Fees/reconcilationFeeDetails?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&type=" +
            type,
          body: this.buildReconFeePayload(item),
          context: this,
          token: this.$store.state.userData.token,
          subjects: true,
        });

        let list = [];
        if (Array.isArray(res)) {
          list = res;
        } else if (res && Array.isArray(res.data)) {
          list = res.data;
        }

        this.$set(this.feeBreakdownCache, cacheKey, list);
      } catch (error) {
        console.error("Error loading fee breakdown:", error);
        this.$set(this.feeBreakdownCache, cacheKey, []);
        this.$bvToast.toast(
          type === "discount"
            ? "Failed to load discount details"
            : "Failed to load actual fee details",
          {
            title: this.$t("Error"),
            variant: "danger",
            solid: true,
          }
        );
      } finally {
        this.feeBreakdownLoadingKey = null;
      }
    },

    getFeeStudentKey(feeRow) {
      return `${this.feeBreakdownModalType}_${this.feeBreakdownModalIndex}_${feeRow.feeTypeID}`;
    },

    getFeeStudentList(feeRow) {
      return this.feeStudentCache[this.getFeeStudentKey(feeRow)] || [];
    },

    isFeeStudentLoading(feeRow) {
      return (
        this.showFeeStudentModal &&
        this.feeStudentModalFeeRow &&
        this.feeStudentModalFeeRow.feeTypeID === feeRow.feeTypeID &&
        this.feeStudentLoadingKey === this.getFeeStudentKey(feeRow)
      );
    },

    openFeeStudentModal(feeRow) {
      if (!this.feeBreakdownModalItem || feeRow.feeTypeID === undefined) {
        return;
      }

      this.feeStudentModalFeeRow = feeRow;
      this.showFeeStudentModal = true;
      this.loadFeeStudentDetails(feeRow);
    },

    resetFeeStudentModal() {
      this.feeStudentModalFeeRow = null;
    },

    parseFeeStudentResponse(res) {
      if (Array.isArray(res)) {
        return res;
      }
      if (res && Array.isArray(res.data)) {
        return res.data;
      }
      return [];
    },

    buildFeeStudentRows(list, type) {
      return list.map((student, index) => {
        const fees = Array.isArray(student.fees) ? student.fees : [];
        let amount = 0;
        let paidCount = 0;
        let unpaidCount = 0;

        fees.forEach((fee) => {
          const record = fee.feeRecord || {};
          amount +=
            this.feeBreakdownModalType === "discount"
              ? Number(record.discount) || 0
              : this.feeBreakdownModalType === "advance" 
              ? Number(record.rcvd) || 0
              : Number(record.actualFee) || 0;

          if (String(record.status || "").toLowerCase() === "paid") {
            paidCount += 1;
          } else {
            unpaidCount += 1;
          }
        });

        let status = "—";
        if (fees.length) {
          if (unpaidCount === 0) status = "paid";
          else if (paidCount === 0) status = "unpaid";
          else status = "partial";
        }

        return {
          sno: index + 1,
          grNo: student.grNo || "—",
          studentName: student.studentName || "—",
          fatherName: student.fatherName || "—",
          amount,
          status,
        };
      });
    },

    getFeeStatusVariant(status) {
      const value = String(status || "").toLowerCase();
      if (value === "paid") return "light-success";
      if (value === "unpaid") return "light-danger";
      if (value === "partial") return "light-warning";
      return "light-secondary";
    },

    async loadFeeStudentDetails(feeRow) {
      const cacheKey = this.getFeeStudentKey(feeRow);

      if (
        this.feeStudentCache[cacheKey] ||
        this.feeStudentLoadingKey === cacheKey
      ) {
        return;
      }

      this.feeStudentLoadingKey = cacheKey;

      try {
        const res = await this.post({
          url:
            this.$store.state.domain +
            "Fees/reconcilationStdDetails?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&type=" +
            this.feeBreakdownModalType +
            "&feeTypeID=" +
            feeRow.feeTypeID,
          body: this.buildReconFeePayload(this.feeBreakdownModalItem),
          context: this,
          token: this.$store.state.userData.token,
          subjects: true,
        });

        this.$set(
          this.feeStudentCache,
          cacheKey,
          this.parseFeeStudentResponse(res)
        );
      } catch (error) {
        console.error("Error loading student details:", error);
        this.$set(this.feeStudentCache, cacheKey, []);
        this.$bvToast.toast("Failed to load student details", {
          title: this.$t("Error"),
          variant: "danger",
          solid: true,
        });
      } finally {
        this.feeStudentLoadingKey = null;
      }
    },

    openReport(item, type) {
      let dtF = item.dtFrom.split("T")[0];
      let dtT = item.dtTo.split("T")[0];

      if (type == "left") {
        let url =
          `https://${this.reportDomain}.myskool.app/List/Show?type=left&dbb=` +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&cls=&status=&mob=false&dtFrom=" +
          dtF +
          "&dtTo=" +
          dtT;
        window.open(url, "_blank");
      } else if (type == "exempt") {
        let url =
          `https://${this.reportDomain}.myskool.app/Fee/Show?type=dcr&dtFrom=` +
          dtF +
          "&dtTo=" +
          dtT +
          "&dbb=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&month=&feeType=&format=Exemption&cls=&accId=0";
        window.open(url, "_blank");
      } else if (type == "collection") {
        let url =
          `https://${this.reportDomain}.myskool.app/Fee/Show?type=dcr&dtFrom=` +
          dtF +
          "&dtTo=" +
          dtT +
          "&dbb=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&month=&feeType=&format=Slip wise&cls=&accId=0";
        window.open(url, "_blank");
      }
    },

    AddOpen() {
      if (!this.rangeDate) {
        const fd = new Date();
        const firstDate = `${fd.getFullYear()}-${(fd.getMonth() + 1)
          .toString()
          .padStart(2, "0")}-01`;

        const ld = new Date(fd.getFullYear(), fd.getMonth() + 1, 0);
        const lastDate = `${ld.getFullYear()}-${(ld.getMonth() + 1)
          .toString()
          .padStart(2, "0")}-${ld.getDate().toString().padStart(2, "0")}`;

        this.dateObj.dtFrom = firstDate;
        this.dateObj.dtTo = lastDate;
        this.rangeDate = `${firstDate} to ${lastDate}`;

        this.dateObj.month = fd.getMonth() + 1;
        this.dateObj.year = fd.getFullYear();
      }
      this.visibility2 = true;
      var elem = this.$refs["date"];
      elem.state = undefined;
    },
    setDate(sd, dateStr) {
      // console.log(sd, dateStr);
      if (dateStr) {
        if (sd.length > 1) {
          let date = dateStr.split(" to ");
          if (date.length == 1) {
            this.dateObj.dtFrom = date[0];
            this.dateObj.dtTo = date[0];
          } else {
            this.dateObj.dtFrom = date[0];
            this.dateObj.dtTo = date[1];
          }
        } else {
          this.dateObj.dtFrom = dateStr;
          this.dateObj.dtTo = null;
        }
      } else {
        this.dateObj.dtFrom = null;
        this.dateObj.dtTo = null;
      }
      // console.log(this.dateObj.dtFrom, this.dateObj.dtTo);
    },
    async saveData() {
      var elem = this.$refs["date"];
      if (this.dateObj.dtFrom && this.dateObj.dtTo) {
        elem.state = true;
        // console.log(this.dateObj);

        this.saving = true;
        var status = await this.post({
          url:
            this.$store.state.domain +
            "Fees/saveReconcilation?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          body: this.dateObj,
          // message: "Account added successfully.",
          context: this,
          token: this.$store.state.userData.token,
          subjects: true,
        });
        this.saving = false;
        // console.log(status);
        if (status) {
          // this.items.push(status);
          // this.$store.commit("setReconilData", this.items);
          this.visibility2 = false;
          this.LoadData();
        }
      } else {
        elem.state = false;
      }
    },

    async openSetting() {
      this.settLoading = true;
      let res = await this.post({
        url:
          this.$store.state.domain +
          "Settings/getSettings?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        body: ["reconcil-opening"],
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      });

      let obj = res.find((el) => el.key == "reconcil-opening");
      if (!obj) {
        this.settObj = {
          id: 0,
          campusID: this.$store.state.userData.cId,
          key: "reconcil-opening",
          value: "reconcil-opening",
          valueBool: true,
          valueNumber: 0,
        };
      } else this.settObj = obj;

      this.settLoading = false;
      this.visibility = true;
      this.$nextTick(() => {
        var elem = this.$refs["bal"];
        elem.state = undefined;
      });
    },
    CheckVal() {
      var elem = this.$refs["bal"];
      let x = parseInt(this.settObj.valueNumber);
      if (isNaN(x) || x < 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async saveSetting() {
      if (this.CheckVal() == true) {
        this.request = true;
        this.settObj.valueNumber = parseInt(this.settObj.valueNumber);
        var status = await this.post({
          url:
            this.$store.state.domain +
            "Settings/SaveNew?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          body: [this.settObj],
          message: "Opening balance save successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        this.request = false;
        if (status) {
          this.visibility = false;
        }
      }
    },
    async LoadData() {
      this.dataLoading = true;

      var obj = {
        url:
          this.$store.state.domain +
          "FeeReconcilation?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.items = await this.get(obj);
      this.feeBreakdownCache = {};
      this.feeStudentCache = {};
      this.feeBreakdownLoadingKey = null;
      this.feeStudentLoadingKey = null;
      this.showFeeBreakdownModal = false;
      this.showFeeStudentModal = false;
      this.resetFeeBreakdownModal();
      this.resetFeeStudentModal();
      this.dataLoading = false;
    },
    getReconciliationId(item) {
      return item?.id || item?.reconcilationId || item?.reconId || 0;
    },
    openFullReconciliationReport() {
      if (!this.items.length) return;

      const route = this.$router.resolve({
        name: "fee-reconciliation-full-report",
        query: {
          db: this.$store.state.userData.db,
          cID: this.$store.state.userData.cId,
        },
      });
      window.open(route.href, "_blank");
    },
    printReconciliationReport() {
      console.log("Generating reconciliation print report...");

      // Create the HTML content for the print view
      const printContent = this.generatePrintableHTML();

      // Open new window/tab
      const newWindow = window.open(
        "",
        "_blank",
        "width=1200,height=800,scrollbars=yes,resizable=yes"
      );

      if (newWindow) {
        newWindow.document.write(printContent);
        newWindow.document.close();

        // Add print functionality after the content is loaded
        newWindow.onload = function () {
          // Add print button functionality
          const printBtn = newWindow.document.getElementById("printButton");
          if (printBtn) {
            printBtn.addEventListener("click", function () {
              newWindow.print();
            });
          }
        };
      } else {
        alert(
          "Pop-up blocked! Please allow pop-ups for this site to view the reconciliation report."
        );
      }
    },

    generatePrintableHTML() {
      // Calculate totals
      const totalRecords = this.items.length;
      const totalReceived = this.items.reduce(
        (sum, item) => sum + (parseFloat(item.collection) || 0),
        0
      );
      const totalBalance = this.items.reduce(
        (sum, item) => sum + (parseFloat(item.balance) || 0),
        0
      );
      const totalExemptions = this.items.reduce(
        (sum, item) => sum + (parseFloat(item.exempted) || 0),
        0
      );
      const totalDiscounts = this.items.reduce(
        (sum, item) => sum + (parseFloat(item.discount) || 0),
        0
      );

      // Generate table rows
      const tableRows = this.items
        .map(
          (item, index) => `
        <tr ${index % 2 === 0 ? 'class="even-row"' : ""}>
          <td class="text-center">${item.datestr || "N/A"}</td>
          <td class="text-center">
            ${this.monthName(item.month)} ${item.year}
          </td>
          <td class="text-right">${this.formatNumber(item.prevBalance)}</td>
          <td class="text-right">${this.formatNumber(item.dues)}</td>
          <td class="text-center">${item.badDebtsCount || 0}</td>
          <td class="text-right">${this.formatNumber(item.badDebts)}</td>
          <td class="text-center">${item.discountCount || 0}</td>
          <td class="text-right">${this.formatNumber(item.discount)}</td>
          <td class="text-center">${item.exemptCount || 0}</td>
          <td class="text-right">${this.formatNumber(item.exempted)}</td>
          <td class="text-right highlight-received">${this.formatNumber(
            item.collection
          )}</td>
          <td class="text-right highlight-received">${this.formatNumber(
            item.advanceCollection
          )}</td>
          <td class="text-right highlight-balance">${this.formatNumber(
            item.balance
          )}</td>
        </tr>
      `
        )
        .join("");

      return `
        <!DOCTYPE html>
        <html lang="en">
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>Fee Reconciliation Report</title>
          <style>
            * {
              margin: 0;
              padding: 0;
              box-sizing: border-box;
            }
            
            body {
              font-family: 'Arial', sans-serif;
              line-height: 1.4;
              color: #333;
              background-color: #fff;
              padding: 20px;
              font-size: 12px;
            }
            
            .print-header {
              text-align: center;
              margin-bottom: 30px;
              padding: 20px;
              background: linear-gradient(135deg, #7367f0 0%, #9c88ff 100%);
              color: white;
              border-radius: 12px;
              box-shadow: 0 4px 15px rgba(115, 103, 240, 0.3);
            }
            
            .print-header h1 {
              font-size: 28px;
              margin-bottom: 10px;
              font-weight: bold;
            }
            
            .print-header p {
              font-size: 16px;
              opacity: 0.9;
              margin: 5px 0;
            }
            
            .school-info {
              background: #f8f9fa;
              padding: 15px;
              border-radius: 8px;
              margin-bottom: 20px;
              border-left: 4px solid #7367f0;
            }
            
            .school-info h3 {
              color: #7367f0;
              margin-bottom: 10px;
              font-size: 18px;
            }
            
            .info-grid {
              display: grid;
              grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
              gap: 10px;
              margin-bottom: 15px;
            }
            
            .info-item {
              padding: 8px 12px;
              background: white;
              border-radius: 6px;
              border: 1px solid #e9ecef;
            }
            
            .info-label {
              font-weight: bold;
              color: #495057;
              font-size: 11px;
              text-transform: uppercase;
              letter-spacing: 0.5px;
            }
            
            .info-value {
              color: #7367f0;
              font-weight: 600;
              font-size: 14px;
            }
            
            .report-table {
              width: 100%;
              border-collapse: collapse;
              margin-bottom: 25px;
              background: white;
              border-radius: 8px;
              overflow: hidden;
              box-shadow: 0 2px 10px rgba(0,0,0,0.1);
            }
            
            .report-table th {
              background: linear-gradient(135deg, #7367f0 0%, #9c88ff 100%);
              color: white;
              padding: 12px 8px;
              text-align: center;
              font-weight: bold;
              font-size: 11px;
              text-transform: uppercase;
              letter-spacing: 0.5px;
              border: none;
            }
            
            .report-table td {
              padding: 10px 8px;
              border-bottom: 1px solid #e9ecef;
              font-size: 11px;
              vertical-align: middle;
            }
            
            .report-table tr.even-row {
              background-color: #f8f9fa;
            }
            
            .report-table tr:hover {
              background-color: #e3f2fd;
            }
            
            .text-center { text-align: center; }
            .text-right { text-align: right; }
            .text-left { text-align: left; }
            
            .highlight-received {
              background-color: #d4edda !important;
              color: #155724;
              font-weight: bold;
            }
            
            .highlight-balance {
              background-color: #fff3cd !important;
              color: #856404;
              font-weight: bold;
            }
            
            .summary-section {
              background: #f8f9fa;
              padding: 20px;
              border-radius: 8px;
              margin-top: 20px;
              border: 1px solid #e9ecef;
            }
            
            .summary-title {
              color: #7367f0;
              font-size: 16px;
              font-weight: bold;
              margin-bottom: 15px;
              text-align: center;
            }
            
            .summary-grid {
              display: grid;
              grid-template-columns: repeat(2, 1fr);
              gap: 10px;
              max-width: 600px;
              margin: 0 auto;
            }
            
            .summary-card {
              background: white;
              padding: 12px;
              border-radius: 6px;
              text-align: center;
              border: 1px solid #e9ecef;
              box-shadow: 0 2px 4px rgba(0,0,0,0.05);
            }
            
            .summary-card .label {
              font-size: 10px;
              color: #6c757d;
              text-transform: uppercase;
              letter-spacing: 0.5px;
              margin-bottom: 5px;
              font-weight: 500;
            }
            
            .summary-card .value {
              font-size: 14px;
              font-weight: bold;
              color: #7367f0;
            }
            
            .print-controls {
              position: fixed;
              top: 20px;
              right: 20px;
              z-index: 1000;
            }
            
            .print-btn {
              background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
              color: white;
              border: none;
              padding: 12px 20px;
              border-radius: 8px;
              cursor: pointer;
              font-size: 14px;
              font-weight: bold;
              box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);
              transition: all 0.3s ease;
            }
            
            .print-btn:hover {
              transform: translateY(-2px);
              box-shadow: 0 6px 20px rgba(40, 167, 69, 0.4);
            }
            
            .footer {
              text-align: center;
              margin-top: 30px;
              padding: 20px;
              background: #f8f9fa;
              border-radius: 8px;
              color: #6c757d;
              font-size: 11px;
            }
            
            @media print {
              .print-controls {
                display: none !important;
              }
              
              body {
                padding: 10px;
                font-size: 10px;
              }
              
              .print-header {
                background: #7367f0 !important;
                -webkit-print-color-adjust: exact;
                color-adjust: exact;
              }
              
              .report-table th {
                background: #7367f0 !important;
                -webkit-print-color-adjust: exact;
                color-adjust: exact;
              }
              
              .highlight-received {
                background-color: #d4edda !important;
                -webkit-print-color-adjust: exact;
                color-adjust: exact;
              }
              
              .highlight-balance {
                background-color: #fff3cd !important;
                -webkit-print-color-adjust: exact;
                color-adjust: exact;
              }
              
              /* Portrait specific adjustments */
              @page {
                size: A4 portrait;
                margin: 0.5in;
              }
              
              /* Adjust table columns for portrait layout */
              .report-table th:nth-child(1) { width: 25% !important; } /* Date - even wider in portrait */
              .report-table th:nth-child(2) { width: 5% !important; }  /* Month */
              .report-table th:nth-child(3) { width: 8% !important; }  /* Last Balance */
              .report-table th:nth-child(4) { width: 8% !important; }  /* Actual Fee */
              .report-table th:nth-child(5) { width: 5% !important; }  /* Left Count */
              .report-table th:nth-child(6) { width: 8% !important; }  /* Left Total */
              .report-table th:nth-child(7) { width: 5% !important; }  /* Discount Count */
              .report-table th:nth-child(8) { width: 8% !important; }  /* Discount Total */
              .report-table th:nth-child(9) { width: 5% !important; }  /* Exemption Count */
              .report-table th:nth-child(10) { width: 8% !important; } /* Exemption Total */
              .report-table th:nth-child(11) { width: 8% !important; } /* Received */
              .report-table th:nth-child(12) { width: 7% !important; } /* Balance */
              
              .report-table td:nth-child(1) { width: 25% !important; } /* Date cells */
              .report-table td:nth-child(2) { width: 5% !important; }  /* Month cells */
              .report-table td:nth-child(3) { width: 8% !important; }  /* Last Balance cells */
              .report-table td:nth-child(4) { width: 8% !important; }  /* Actual Fee cells */
              .report-table td:nth-child(5) { width: 5% !important; }  /* Left Count cells */
              .report-table td:nth-child(6) { width: 8% !important; }  /* Left Total cells */
              .report-table td:nth-child(7) { width: 5% !important; }  /* Discount Count cells */
              .report-table td:nth-child(8) { width: 8% !important; }  /* Discount Total cells */
              .report-table td:nth-child(9) { width: 5% !important; }  /* Exemption Count cells */
              .report-table td:nth-child(10) { width: 8% !important; } /* Exemption Total cells */
              .report-table td:nth-child(11) { width: 8% !important; } /* Received cells */
              .report-table td:nth-child(12) { width: 7% !important; } /* Balance cells */
              
              /* Ensure date column content doesn't wrap */
              .report-table td:nth-child(1) {
                white-space: nowrap !important;
                overflow: hidden !important;
                text-overflow: ellipsis !important;
                font-size: 9px !important;
              }
            }
          </style>
        </head>
        <body>
          <!-- Print Controls -->
          <div class="print-controls">
            <button id="printButton" class="print-btn">
              🖨️ Print Report
            </button>
          </div>
          
          <!-- Header -->
          <div class="print-header">
            <h1>Fee Reconciliation Report</h1>
            <p>Generated on ${new Date().toLocaleDateString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            })}</p>
          </div>
          
          <!-- School Info -->
          <div class="school-info">
            <h3>Report Summary</h3>
            <div class="info-grid">
              <div class="info-item">
                <div class="info-label">Total Records</div>
                <div class="info-value">${totalRecords}</div>
              </div>
              <div class="info-item">
                <div class="info-label">Report Type</div>
                <div class="info-value">Fee Reconciliation</div>
              </div>
              <div class="info-item">
                <div class="info-label">Status</div>
                <div class="info-value">Complete</div>
              </div>
            </div>
          </div>
          
          <!-- Main Table -->
          <table class="report-table">
            <thead>
              <tr>
                <th style="width: 20%;">Date</th>
                <th style="width: 6%;">Month</th>
                <th style="width: 9%;">Last Balance</th>
                <th style="width: 9%;">Actual Fee</th>
                <th style="width: 6%;">Left Count</th>
                <th style="width: 9%;">Left Total</th>
                <th style="width: 6%;">Discount Count</th>
                <th style="width: 9%;">Discount Total</th>
                <th style="width: 6%;">Exemption Count</th>
                <th style="width: 8%;">Exemption Total</th>
                <th style="width: 6%;">Received</th>
                <th style="width: 6%;">Advance</th>
                <th style="width: 6%;">Balance</th>
              </tr>
            </thead>
            <tbody>
              ${tableRows}
            </tbody>
          </table>
          
          <!-- Summary Cards -->
          <div class="summary-section">
            <div class="summary-title">Financial Summary</div>
            <div class="summary-grid">
              <div class="summary-card">
                <div class="label">Total Received</div>
                <div class="value">${this.formatNumber(totalReceived)}</div>
              </div>
              <div class="summary-card">
                <div class="label">Total Balance</div>
                <div class="value">${this.formatNumber(totalBalance)}</div>
              </div>
              <div class="summary-card">
                <div class="label">Total Exemptions</div>
                <div class="value">${this.formatNumber(totalExemptions)}</div>
              </div>
              <div class="summary-card">
                <div class="label">Total Discounts</div>
                <div class="value">${this.formatNumber(totalDiscounts)}</div>
              </div>
            </div>
          </div>
          
          
        </body>
        </html>
      `;
    },

    formatNumber(value) {
      if (!value || isNaN(value)) return "0";
      return parseFloat(value).toLocaleString("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
    },
  },
};
</script>
<style scoped>
.recon-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  width: 100%;
  overflow: visible;
}

.recon-toolbar-left,
.recon-toolbar-right {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
}

.recon-toolbar-right {
  margin-left: auto;
}

.recon-toolbar-left .btn-icon {
  padding-left: 0.65rem;
  padding-right: 0.65rem;
}

.recon-print-full-btn {
  min-width: 168px;
}

.recon-data-table {
  background: #fff;
}

.recon-data-table ::v-deep th {
  background: #f8f9fa !important;
  color: #374151 !important;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.72rem;
  letter-spacing: 0.03em;
  border-color: #e5e7eb !important;
  vertical-align: middle;
}

.recon-data-table ::v-deep td {
  background: #fff;
  border-color: #e5e7eb !important;
  vertical-align: middle;
}

.recon-data-table ::v-deep tbody tr:nth-child(even) td {
  background: #fafbfc;
}

.recon-date-cell {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 150px;
}

.recon-date-range {
  font-weight: 600;
  color: #1f2937;
  font-size: 0.84rem;
  line-height: 1.3;
}

.recon-date-month {
  font-size: 0.78rem;
  color: #6b7280;
  font-weight: 500;
}

.recon-value-badge {
  display: inline-block;
  min-width: 52px;
  padding: 0.35rem 0.55rem;
  border-radius: 6px;
  background: #f3f4f6;
  color: #111827;
  border: 1px solid #e5e7eb;
  font-weight: 600;
  font-size: 0.84rem;
  line-height: 1.2;
  text-align: center;
}

.recon-value-badge--clickable {
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    background: #e5e7eb;
    border-color: #d1d5db;
  }
}

.recon-value-badge--received {
  background: #ecfdf3;
  color: #166534;
  border-color: #bbf7d0;
}

.recon-value-badge--balance {
  background: #fef2f2;
  color: #991b1b;
  border-color: #fecaca;
}

.table.table-sm th {
  text-align: center;
}

.clickable-fee-badge {
  cursor: pointer;
  background-color: #f3f4f6 !important;
  color: #1f2937 !important;
  border: 1px solid #e5e7eb !important;
  font-weight: 600;
  padding: 0.45rem 0.65rem;
  transition: all 0.2s ease;

  &:hover {
    background-color: #e5e7eb !important;
    color: #111827 !important;
    border-color: #d1d5db !important;
    box-shadow: 0 1px 4px rgba(15, 23, 42, 0.08);
  }
}

.unadjusted-fee-text {
  font-weight: 600;
  color: #7367f0 !important;
  text-decoration: none;
  line-height: 1.2;
}

.fee-breakdown-link,
.fee-breakdown-count-link {
  font-weight: 600;
  color: #7367f0 !important;
  text-decoration: none;
  line-height: 1.2;

  &:hover:not(:disabled) {
    color: #5e50ee !important;
    text-decoration: underline;
  }

  &:disabled {
    opacity: 0.7;
    cursor: wait;
  }
}

.fee-breakdown-count-link {
  font-weight: 500;
}

.fee-modal-meta {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.65rem 1rem;
  padding: 0.85rem 1rem;
  border: 1px solid #ebe9f1;
  border-radius: 8px;
  background: #f8f8f8;
}

.fee-modal-meta-row {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.fee-modal-meta-label {
  color: #6e6b7b;
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.fee-modal-meta-value {
  color: #2f2b3d;
  font-size: 0.9rem;
  font-weight: 600;
}

.fee-modal-meta-total {
  color: #7367f0;
}

::v-deep .fee-student-modal-body {
  max-height: 58vh;
  overflow-y: auto;
  padding-top: 0.75rem;
}

.fee-student-table-wrap {
  border: 1px solid #ebe9f1;
  border-radius: 8px;
  overflow: hidden;
}

.actual-fee-breakdown-table {
  th {
    vertical-align: middle;
    white-space: nowrap;
  }

  td {
    vertical-align: middle;
  }

  tfoot th,
  tfoot td {
    background: #f8f8f8;
    vertical-align: middle;
  }
}

.student-count-badge {
  min-width: 52px;
  font-weight: 600;
}

.fee-student-details-table {
  th {
    vertical-align: middle;
    white-space: nowrap;
  }

  td {
    vertical-align: middle;
  }

  tfoot th,
  tfoot td {
    background: #f8f8f8;
    vertical-align: middle;
  }
}
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
